import React, { useState, useCallback, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import ReactDOM from "react-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import avatar from "assets/img/faces/marc.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import url from "assets/js/config.js";

import CustomTabs from "components/CustomTabs/CustomTabs.js";
import BugReport from "@material-ui/icons/BugReport";
import MultiStep from "react-multistep";
//import {Basic_details} from "views/hotel_owners/UserProfile/profile_template.js";
import { Multiselect } from "multiselect-react-dropdown";
import { Photo_details } from "views/hotel_owners/UserProfile/photo_gallery.js";

import Employee_availability from "./employee_availabilty.js";

const onChange = (e) => {
  console.log(e.target.files);
};

var ht;
var is_catering;
var catering_type;
var capacity;
var that;
var business_description;
var establishment_type;
var specialization_area;
var alt_msisdn;
var email_id;
var website;
var no_of_employees;
var year_of_establishment;
var business_name;
var state;
var address;
var address1;
var name;
var images1;
var file01;
var file02;
var msisdn;
var experience_area;
var city;
var locality;
var memberuniqid;
var pin;
var is_catering = "no";
const mystyle = {
  width: "250px",
  fontSize: "14px",
};
const mystyle1 = {
  fontSize: "14px",
};
const FileInput = (props) => (
  <input type="file" name="file" multiple value={props.value} />
);

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

var form_value = 0;

var that;
export default class Welcome extends React.Component {
  constructor(props) {
    super(props);

    var education = [];
    var specialization = [];
    var languages = [];

    this.state = {
      data: props.value,
      files_upload_aadhar_card: props.value,
      files_upload_pan_card: props.value,
    };

    this.handleFirstNameChanged = this.handleFirstNameChanged.bind(this);
    this.handle_hotel_type = this.handle_hotel_type.bind(this);
    this.handle_address = this.handle_address.bind(this);
    this.handle_address1 = this.handle_address1.bind(this);
    this.handle_city = this.handle_city.bind(this);
    this.handle_state = this.handle_state.bind(this);
    this.handle_pin = this.handle_pin.bind(this);
    this.handle_locality = this.handle_locality.bind(this);
    this.handle_year_of_establishment = this.handle_year_of_establishment.bind(
      this
    );
    this.handle_no_of_employees = this.handle_no_of_employees.bind(this);
    this.handle_business_description = this.handle_business_description.bind(
      this
    );
    this.handle_specialization_area = this.handle_specialization_area.bind(
      this
    );
    this.handle_catering_capacity = this.handle_catering_capacity.bind(this);
    this.handle_website = this.handle_website.bind(this);
    this.handle_email_id = this.handle_email_id.bind(this);
    this.handle_alt_msisdn = this.handle_alt_msisdn.bind(this);
    this.handle_msisdn = this.handle_msisdn.bind(this);
    this.handle_fname = this.handle_fname.bind(this);
    this.handle_capacity = this.handle_capacity.bind(this);
    this.handle_file = this.handle_file.bind(this);
    this.handle_file_aadhar_card = this.handle_file_aadhar_card.bind(this);
    this.handle_file_pan_card = this.handle_file_pan_card.bind(this);

    that = this;
  }

  handleFirstNameChanged(event) {
    //alert(event.target.value);
    this.setState({ name: event.target.value });
  }
  handle_hotel_type(event) {
    //alert(event.target.value);
    this.setState({ hoteltype: event.target.value });
  }
  handle_file(event) {
    //document.querySelector("#myform").value=event.target.value;
    if (this.state.files_upload === undefined) {
      this.state.files_upload = "";
    }
    //alert(event.target.files);

    this.setState({ files_upload: event.target.files });
  }

  // ************** KYC ********************//
  handle_file_aadhar_card(event) {
    //document.querySelector("#myform").value=event.target.value;
    if (this.state.files_upload_aadhar_card === undefined) {
      this.state.files_upload_aadhar_card = "";
    }
    //alert(event.target.files);

    this.setState({ files_upload_aadhar_card: event.target.files_aadhar_card });
  }
  handle_file_pan_card(event) {
    //document.querySelector("#myform").value=event.target.value;
    if (this.state.files_upload_pan_card === undefined) {
      this.state.files_upload_pan_card = "";
    }
    //alert(event.target.files);

    this.setState({ files_upload_pan_card: event.target.files_pan_card });
  }

  handle_address(event) {
    //alert(event.target.value);
    this.setState({ address: event.target.value });
  }
  handle_address1(event) {
    //alert(event.target.value);
    this.setState({ address1: event.target.value });
  }
  handle_city(event) {
    //alert(event.target.value);
    this.setState({ city: event.target.value });
  }
  handle_state(event) {
    //alert(event.target.value);
    this.setState({ state: event.target.value });
  }
  handle_pin(event) {
    //alert(event.target.value);
    this.setState({ pin: event.target.value });
  }

  handle_locality(event) {
    //alert(event.target.value);
    this.setState({ locality: event.target.value });
  }
  handle_year_of_establishment(event) {
    //alert(event.target.value);
    that.setState({ yearofestablishment: event.target.value });
  }
  handle_no_of_employees(event) {
    //alert(event.target.value);
    that.setState({ noofemployees: event.target.value });
  }
  handle_business_description(event) {
    //alert(event.target.value);
    that.setState({ businessdescription: event.target.value });
  }

  handle_specialization_area(event) {
    //alert(event.target.value);
    that.setState({ specializationarea: event.target.value });
  }
  handle_establishment_type(event) {
    //alert(event.target.value);
    that.setState({ establishmenttype: event.target.value });
  }

  handle_catering_capacity(event) {
    //that.setState({cateringcapacity1: false});
    delete that.state.cateringcapacity1;
    that.setState({ cateringcapacity: event.target.value });
    that.setState({ catering_data1: "none" });
    is_catering = event.target.value;

    document.querySelector("#catering_data1").style.display = "none";
  }
  handle_catering_capacity1(event) {
    delete that.state.cateringcapacity;
    // that.setState({cateringcapacity: false});
    is_catering = event.target.value;
    that.setState({ cateringcapacity1: event.target.value });
    that.setState({ catering_data1: "block" });
    document.querySelector("#catering_data1").style.display = "block";
  }
  handle_email_id(event) {
    that.setState({ email_id: event.target.value });
    //that.setState({cateringcapacity: "off"});
  }
  handle_website(event) {
    that.setState({ website: event.target.value });
    //that.setState({cateringcapacity: "off"});
  }
  handle_msisdn(event) {
    that.setState({ msisdn: event.target.value });
    //that.setState({cateringcapacity: "off"});
  }
  handle_alt_msisdn(event) {
    that.setState({ alt_msisdn: event.target.value });
    //that.setState({cateringcapacity: "off"});
  }

  handle_fname(event) {
    that.setState({ fname: event.target.value });
    //that.setState({cateringcapacity: "off"});
  }

  handle_capacity(event) {
    //alert(event.target.value);
    that.setState({ capacity: event.target.value });
  }
  handle_website(event) {
    //alert(event.target.value);
    that.setState({ website: event.target.value });
  }
  handle_catering_type(event) {
    var data = event.target.value;
    delete that.state.catering_non_veg;
    delete that.state.catering_veg;
    delete that.state.catering_both;
    if (data == "non_veg") {
      that.setState({ catering_non_veg: event.target.value });
      that.setState({ catering_type: event.target.value });
    }
    if (data == "veg") {
      that.setState({ catering_veg: event.target.value });
      that.setState({ catering_type: event.target.value });
    }
    if (data == "both") {
      that.setState({ catering_both: event.target.value });
      that.setState({ catering_type: event.target.value });
    }
  }

  componentDidMount() {
    var ootel_auth_token = localStorage.getItem("ootel_auth_token");
    var postData = { auth_token: ootel_auth_token };
    var ootel_auth_token = localStorage.getItem("ootel_auth_token");
    var postData = { auth_token: ootel_auth_token };

    var ootel_auth_token = localStorage.getItem("ootel_auth_token");
    var postData = { auth_token: ootel_auth_token };
    const rawResponse = fetch(url.server_url + "/get_hotel_owners", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    })
      .then((res) => res.json())
      .then((data) => {
        try {
          if (data.error.length != 0) {
            alert(data.error);
            return;
          }
        } catch (e) {}

        try {
          var data1 = data.data;

          name = data1[0].name;
          business_name = data1[0].business_name;
          capacity = data1[0].capacity;

          var pan_number = data1[0].pan_no;
          var adhaar_number = data1[0].aadhar_no;
          specialization_area = data1[0].specialization_area;

          var nominee = data1[0].nominee;
          email_id = data1[0].email_id;
          website = data1[0].website;

          var blood_group = data1[0].blood_group;

          msisdn = data1[0].msisdn;
          var gender = data1[0].gender;
          var nominee_relation = data1[0].nominee_relation;
          var emergency_msisdn = data1[0].emergency_msisdn;

          address = data1[0].address;
          state = data1[0].state;
          city = data1[0].city;

          pin = data1[0].pin;
          locality = data1[0].locality;
          memberuniqid =
            data1[0].memberuniqid == ""
              ? "Contact Admin for Member Customer Id"
              : data1[0].memberuniqid;
          var address_permanent = data1[0].address_permanent;
          var state_permanent = data1[0].state_permanent;
          var city_permanent = data1[0].city_permanent;

          var pin_permanent = data1[0].pin_permanent;
          var locality_permanent = data1[0].locality_permanent;
          var abroad_job = data1[0].abroad_job;

          var dob = data1[0].dob;
          document.querySelector("#name").value = name;
          document.querySelector("#msisdn").value = msisdn;
          document.querySelector("#adhaar_number").value = adhaar_number;
          try {
            document.querySelector("#blood_group").value = blood_group;
          } catch (e) {}
          try {
            document.querySelector(
              "#nominee_relation"
            ).value = nominee_relation;
          } catch (e) {}
          document.querySelector("#email_id").value = email_id;
          document.querySelector("#emergency_msisdn").value = emergency_msisdn;
          document.querySelector("#pan_number").value = pan_number;
          document.querySelector("#nominee").value = nominee;
          document.querySelector("#dob").value = dob;

          document.querySelector("#state").value = state;
          document.querySelector("#address").value = address;
          document.querySelector("#locality").value = locality;
          document.querySelector("#memberuniqid").innerHTML = memberuniqid;
          document.querySelector("#pin").value = pin;
          document.querySelector("#city").value = city;

          document.querySelector("#state_permanent").value = state_permanent;
          document.querySelector(
            "#address_permanent"
          ).value = address_permanent;
          document.querySelector(
            "#locality_permanent"
          ).value = locality_permanent;
          document.querySelector("#pin_permanent").value = pin_permanent;
          document.querySelector("#city_permanent").value = city_permanent;

          var work_experience = data1[0].total_experience;
          var salary = data1[0].salary;
          var bank_account_no = data1[0].bank_account_no;
          var ifsc_code = data1[0].ifsc_code;
          document.querySelector("#work_experience").value = work_experience;
          document.querySelector("#salary").value = salary;
          document.querySelector("#ifsc_code").value = ifsc_code;
          document.querySelector("#bank_account_no").value = bank_account_no;

          var details = JSON.parse(data1[0].work_experience);

          try {
            for (var i = 0; i < details.length; i++) {
              var org = details[i].organization;
              var years = details[i].years;
              var role = details[i].role;

              var url1 = new URL(window.location.href);
              var c = url1.searchParams.get("type");

              if (c == "view") {
                var html =
                  "<tr><td>" +
                  org +
                  "</td><td>" +
                  years +
                  "</td><td>" +
                  role +
                  "</td></tr>";
              } else {
                var html =
                  "<tr><td>" +
                  org +
                  "</td><td>" +
                  years +
                  "</td><td>" +
                  role +
                  "</td><td><button class='delete'>Delete</button></td></tr>";
              }

              var tableRef = document
                .getElementById("experience_table")
                .getElementsByTagName("tbody")[0];

              var newRow = tableRef.insertRow(tableRef.rows.length);
              newRow.innerHTML = html;
            }
            try {
              var classname = document.getElementsByClassName("delete");

              var myFunction = function(e) {
                e.preventDefault();
                this.parentNode.parentNode.remove();
              };

              for (var i = 0; i < classname.length; i++) {
                classname[i].addEventListener("click", myFunction, false);
              }
            } catch (e) {
              console.log(e.message);
            }
          } catch (e) {}

          var gender_array = document.querySelectorAll(".gender");

          for (var i = 0; i < gender_array.length; i++) {
            if (gender_array[i].value == gender) {
              gender_array[i].checked = true;
            }
          }

          var abroad_job_array = document.querySelectorAll(".abroad_job");

          for (var i = 0; i < abroad_job_array.length; i++) {
            if (abroad_job_array[i].value == abroad_job) {
              abroad_job_array[i].checked = true;
            }
          }

          try {
            var images1 = data1[0].photo.split("<>");
            var photos = [];
            for (var i = 0; i < images1.length; i++) {
              if (images1[i] != "") {
                photos.push({
                  src: url.image_url + "/" + images1[i],
                  width: 1,
                  height: 1,
                });
              }
            }
            ReactDOM.render(
              <Photo_details data={photos} />,
              document.getElementById("photo_details")
            );
          } catch (e) {}

          // ************* KYC *****************//
          // ************ Aadhar Card ***********//
          try {
            var file01 = data1[0].aadhar_card.split("<>");
            var files = [];
            for (var i = 0; i < file01.length; i++) {
              if (file01[i] != "") {
                files.push({
                  src: url.image_url + "/" + file01[i],
                  width: 1,
                  height: 1,
                });
              }
            }
            ReactDOM.render(
              <aadhar_card_details data={files} />,
              document.getElementById("aadhar_card_details")
            );
          } catch (e) {}
          // ************* Pan Card *****************//
          try {
            var file02 = data1[0].pan_card.split("<>");
            var files = [];
            for (var i = 0; i < file02.length; i++) {
              if (file02[i] != "") {
                files.push({
                  src: url.image_url + "/" + file02[i],
                  width: 1,
                  height: 1,
                });
              }
            }
            ReactDOM.render(
              <pan_card_details data={files} />,
              document.getElementById("pan_card_details")
            );
          } catch (e) {}

          //For view profile

          document.querySelector("#name").innerHTML = name;
          document.querySelector("#msisdn").innerHTML = msisdn;
          document.querySelector("#adhaar_number").innerHTML = adhaar_number;
          document.querySelector("#blood_group_view").innerHTML = blood_group;
          document.querySelector("#email_id").innerHTML = email_id;
          document.querySelector(
            "#emergency_msisdn"
          ).innerHTML = emergency_msisdn;
          document.querySelector("#pan_number").innerHTML = pan_number;
          document.querySelector("#nominee").innerHTML = nominee;
          document.querySelector("#nominee_relation").innerHTML =
            data1[0].nominee_relation;
          document.querySelector("#dob").innerHTML = dob;

          document.querySelector("#state").innerHTML = state;
          document.querySelector("#address").innerHTML = address;
          document.querySelector("#locality").innerHTML = locality;
          document.querySelector("#pin").innerHTML = pin;
          document.querySelector("#city").innerHTML = city;

          document.querySelector(
            "#state_permanent"
          ).innerHTML = state_permanent;
          document.querySelector(
            "#address_permanent"
          ).innerHTML = address_permanent;
          document.querySelector(
            "#locality_permanent"
          ).innerHTML = locality_permanent;
          document.querySelector("#pin_permanent").innerHTML = pin_permanent;
          document.querySelector("#city_permanent").innerHTML = city_permanent;

          var work_experience = data1[0].total_experience;
          var salary = data1[0].salary;
          var bank_account_no = data1[0].bank_account_no;
          var ifsc_code = data1[0].ifsc_code;
          document.querySelector(
            "#work_experience"
          ).innerHTML = work_experience;
          document.querySelector("#salary").innerHTML = salary;
          document.querySelector("#ifsc_code").innerHTML = ifsc_code;
          document.querySelector(
            "#bank_account_no"
          ).innerHTML = bank_account_no;
          document.querySelector("#abroad_job").innerHTML = abroad_job;
          var html = "";
          var x = data1[0].heighest_eductaion;
          x = JSON.parse(x);
          for (var i = 0; i < x.length; i++) {
            html = html + x[i].name + "<br/>";
          }

          document.querySelector("#education").innerHTML = html;

          var html = "";
          var x = data1[0].education_specialization;
          x = JSON.parse(x);
          for (var i = 0; i < x.length; i++) {
            html = html + x[i].name + "<br/>";
          }

          document.querySelector("#specialization").innerHTML = html;

          var html = "";
          var x = data1[0].languages;
          x = JSON.parse(x);
          for (var i = 0; i < x.length; i++) {
            html = html + x[i].name + "<br/>";
          }

          document.querySelector("#languages").innerHTML = html;

          var html = "";
          var x = data1[0].area_of_experience;

          x = JSON.parse(x);
          for (var i = 0; i < x.length; i++) {
            html = html + x[i].name + "<br/>";
          }

          document.querySelector("#area_of_experience").innerHTML = html;
        } catch (e) {
          console.log(e.message);
        }
      })
      .catch((err) => {
        console.error("Error: ", err);
      });

    // var refferer_msisdn_o = localStorage.getItem("refferedby_msisdn");
    // if (refferer_msisdn_o == undefined)
    // {
    //   alert("Hi");
    //   document.querySelector("#pay_to_use").style.display = "block";
    // }
    document
      .querySelector("#pay_to_use")
      .addEventListener("click", function(e) {
        e.preventDefault();
        var ootel_auth_token = localStorage.getItem("ootel_auth_token");
        var msisdn = localStorage.getItem("ootel_msisdn");
        var refferer_msisdn = localStorage.getItem("refferedby_msisdn");
        var postData = {
          msisdn: msisdn,
          auth_token: ootel_auth_token,
          refferer_msisdn: refferer_msisdn,
        };
        const rawResponse = fetch(url.server_url + "/add_member_rewards", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        })
          .then((res) => res.json())
          .then((data) => {
            try {
              if (data.error.length != 0) {
                alert(data.error);
                return;
              }
            } catch (e) {}
            alert(data.data);
            document.location.reload();
          })
          .catch((err) => {
            console.error("Error: ", err);
          });
      });

    document.querySelector("#myform").addEventListener("submit", function(e) {
      e.preventDefault();
    });

    try {
      document.querySelector("#update").addEventListener("click", function(e) {
        e.preventDefault();

        const formData = new FormData(document.querySelector("#myform"));
        var ootel_auth_token = localStorage.getItem("ootel_auth_token");
        formData.append("auth_token", ootel_auth_token);

        formData.append("education", JSON.stringify(that.education));
        formData.append("specialization", JSON.stringify(that.specialization));
        formData.append("languages", JSON.stringify(that.languages));
        formData.append(
          "experience_area",
          JSON.stringify(that.experience_area)
        );

        var work_experience = [];
        var loop = document
          .querySelector("#experience_table")
          .getElementsByTagName("tbody")[0];
        var loop = loop.querySelectorAll("tr");
        for (var i = 0; i < loop.length; i++) {
          var org = loop[i].getElementsByTagName("td")[0].innerHTML;
          var years = loop[i].getElementsByTagName("td")[1].innerHTML;
          var role = loop[i].getElementsByTagName("td")[2].innerHTML;

          work_experience.push({
            organization: org,
            years: years,
            role: role,
          });
        }

        formData.append("work_experience", JSON.stringify(work_experience));
        const rawResponse = fetch(url.server_url + "/add_employees", {
          method: "POST",
          body: formData,
        })
          .then((res) => res.json())
          .then((data) => {
            if (typeof data.error != "undefined") {
              try {
                alert(data.error);
              } catch (e) {
                console.log(e.message);
              }
            } else {
              alert(data.data);
              document.location.reload();
            }
          })
          .catch((err) => {
            console.error("Error: ", err);
          });
      });
    } catch (e) {}

    try {
      document.querySelector("#profile").addEventListener("click", function(e) {
        window.location.href = window.location.pathname + "?type=view";
      });
    } catch (e) {}

    try {
      document
        .querySelector("#edit_profile")
        .addEventListener("click", function(e) {
          window.location.href = window.location.pathname + "?type=update";
          document.querySelector("#title").innerHTML =
            "<h5>Update Your Profile</h5>";
        });
    } catch (e) {}

    try {
      document
        .querySelector("#add_work")
        .addEventListener("click", function(e) {
          e.preventDefault();

          var org = document.querySelector("#org").value;
          var years = document.querySelector("#years").value;
          var role = document.querySelector("#role").value;

          if (org == "" || years == "" || role == "") {
            alert("All fields are Required");
            return;
          }

          var url1 = new URL(window.location.href);
          var c = url1.searchParams.get("type");
          if (c == "view") {
            var html =
              "<tr><td>" +
              org +
              "</td><td>" +
              years +
              "</td><td>" +
              role +
              "</td></tr>";
          } else {
            var html =
              "<tr><td>" +
              org +
              "</td><td>" +
              years +
              "</td><td>" +
              role +
              "</td><td><button class='delete'>Delete</button></td></tr>";
          }

          var tableRef = document
            .getElementById("experience_table")
            .getElementsByTagName("tbody")[0];

          var newRow = tableRef.insertRow(tableRef.rows.length);
          newRow.innerHTML = html;

          var org = (document.querySelector("#org").value = "");
          var years = (document.querySelector("#years").value = "");
          var role = (document.querySelector("#role").value = "");

          try {
            var classname = document.getElementsByClassName("delete");

            var myFunction = function(e) {
              e.preventDefault();
              this.parentNode.parentNode.remove();
            };

            for (var i = 0; i < classname.length; i++) {
              classname[i].addEventListener("click", myFunction, false);
            }
          } catch (e) {
            console.log(e.message);
          }
        });
    } catch (e) {}

    var url1 = new URL(window.location.href);
    var c = url1.searchParams.get("type");
    var view;
    if (c == "view") {
      view = true;
    } else {
      view = false;
    }

    if (c != "view") {
      var postData = { auth_token: ootel_auth_token };

      const rawResponse1 = fetch(url.server_url + "/get_experience_area", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (typeof data.error != "undefined") {
            try {
              alert(data.error);
            } catch (e) {
              console.log(e.message);
            }
          } else {
            this.experience_area = JSON.parse(data.data_selected);
            this.education = JSON.parse(data.data1_selected);
            this.specialization = JSON.parse(data.data2_selected);
            this.languages = JSON.parse(data.data3_selected);

            ReactDOM.render(
              <Multiselect
                options={data.data} // Options to display in the dropdown
                selectedValues={JSON.parse(data.data_selected)} // Preselected value to persist in dropdown
                onSelect={this.onSelect_area_of_experience} // Function will trigger on select event
                onRemove={this.onRemove_area_of_experience} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
              />,
              document.getElementById("area_of_experience")
            );

            ReactDOM.render(
              <Multiselect
                options={data.data1} // Options to display in the dropdown
                selectedValues={JSON.parse(data.data1_selected)} // Preselected value to persist in dropdown
                onSelect={this.onSelect_education} // Function will trigger on select event
                onRemove={this.onRemove_education} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
              />,
              document.getElementById("education")
            );
            var data2_selected = JSON.parse(data.data2_selected);

            ReactDOM.render(
              <Multiselect
                options={data.data2} // Options to display in the dropdown
                selectedValues={data2_selected} // Preselected value to persist in dropdown
                onSelect={this.onSelect_specialization} // Function will trigger on select event
                onRemove={this.onRemove_specialization} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
              />,
              document.getElementById("specialization")
            );

            var data3_selected = JSON.parse(data.data3_selected);
            ReactDOM.render(
              <Multiselect
                options={data.data3} // Options to display in the dropdown
                selectedValues={data3_selected} // Preselected value to persist in dropdown
                onSelect={this.onSelect_languages} // Function will trigger on select event
                onRemove={this.onRemove_languages} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
              />,
              document.getElementById("languages")
            );

            try {
              document
                .querySelector("#same_adr")
                .addEventListener("click", function(e) {
                  e.preventDefault();
                  var x = document.querySelector("#address").value;
                  document.querySelector("#address_permanent").value = x;
                  var x = document.querySelector("#state").value;
                  document.querySelector("#state_permanent").value = x;
                  var x = document.querySelector("#city").value;
                  document.querySelector("#city_permanent").value = x;
                  var x = document.querySelector("#locality").value;
                  document.querySelector("#locality_permanent").value = x;
                  var x = document.querySelector("#pin").value;
                  document.querySelector("#pin_permanent").value = x;
                });
            } catch (e) {}
          }
        })
        .catch((err) => {
          console.error("Error: ", err);
        });
    }
  }

  onSelect_area_of_experience(selectedList, selectedItem) {
    that.experience_area = "";
    that.experience_area = selectedList;
  }

  onRemove_area_of_experience(selectedList, removedItem) {
    that.experience_area = "";
    that.experience_area = selectedList;
  }
  onSelect_education(selectedList, selectedItem) {
    that.education = "";
    that.education = selectedList;
  }

  onRemove_education(selectedList, removedItem) {
    that.education = "";
    that.education = selectedList;
  }

  onSelect_specialization(selectedList, selectedItem) {
    that.specialization = "";
    that.specialization = selectedList;
    // alert(that.specialization)
  }

  onRemove_specialization(selectedList, removedItem) {
    that.specialization = "";
    that.specialization = selectedList;
  }

  onSelect_languages(selectedList, selectedItem) {
    that.languages = "";
    that.languages = selectedList;
  }

  onRemove_languages(selectedList, removedItem) {
    that.languages = "";
    that.languages = selectedList;
  }

  render() {
    const Profile = () => (
      <div>
        {new Counter_edit().render(this.state.data)}
        <hr />
      </div>
    );

    var url = new URL(window.location.href);
    var c = url.searchParams.get("type");
    var view;
    if (c == "view") {
      view = true;
    } else {
      view = false;
    }

    return (
      <div>
        {view ? (
          <div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomTabs
                  title=""
                  headerColor="primary"
                  tabs={[
                    {
                      tabName: "View Profile",
                      tabIcon: BugReport,
                      tabContent: (
                        <div>
                          <h5 id="title">Your Profile</h5>
                          <form
                            id="myform"
                            name="myform"
                            style={mystyle1}
                            encType="multipart/form-data"
                          >
                            <div id="data">{<Profile />}</div>
                            <div style={{ float: "right" }}></div>
                          </form>
                          <div style={{ display: "inline-block", width: "" }}>
                            {" "}
                            &nbsp; &nbsp;
                          </div>
                          <button id="edit_profile" className="btn btn-primary">
                            Edit
                          </button>
                          <div style={{ display: "inline-block", width: "" }}>
                            {" "}
                            &nbsp; &nbsp;
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomTabs
                  title=""
                  headerColor="primary"
                  tabs={[
                    {
                      tabName: "Profile Update",
                      tabIcon: BugReport,
                      tabContent: (
                        <div>
                          <h5 id="title">Update Profile</h5>
                          <form
                            id="myform"
                            name="myform"
                            style={mystyle1}
                            encType="multipart/form-data"
                          >
                            {new Counter().render(this.state.data)}
                          </form>
                          <div style={{ float: "right" }}>
                            <button id="profile" className="btn btn-primary">
                              View Profile
                            </button>
                            <div style={{ display: "inline-block", width: "" }}>
                              {" "}
                              &nbsp; &nbsp;
                            </div>

                            <button
                              id="update"
                              type="submit"
                              value="0"
                              className="btn btn-primary"
                            >
                              Save All
                            </button>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
          </div>
        )}
      </div>
    );
  }
}

class Counter extends React.Component {
  render() {
    return (
      <div>
        <h6>Basic Details</h6>

        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <b> Name:</b>
            <span className="required"></span>
            <input
              type="text"
              name="fname"
              id="name"
              style={mystyle}
              className="form-control u-full-width"
            />
            <b> Mobile:</b>
            <span className="required"></span>
            <input
              type="text"
              disabled
              id="msisdn"
              style={mystyle}
              className="form-control u-full-width"
            />
            <b> Gender:</b>
            <span className="required"></span>
            <br />
            Male:
            <input
              type="radio"
              value="male"
              defaultChecked
              name="gender"
              className="gender"
              style={{ width: "10px" }}
              className="gender  u-full-width"
            />
            &nbsp;&nbsp;&nbsp;Female:
            <input
              type="radio"
              value="female"
              name="gender"
              className="gender"
              style={{ width: "10px" }}
              className="gender  u-full-width"
            />
            <br />
            <b> Emergency Contact Number:</b>
            <span className="required"></span>
            <input
              type="text"
              id="emergency_msisdn"
              name="emergency_msisdn"
              style={mystyle}
              className="form-control"
            />
            <b> Email ID:</b>
            <input
              type="email"
              id="email_id"
              name="email_id"
              style={mystyle}
              className="form-control"
            />
            <b> Date of Birth:</b>
            <span className="required"></span>
            <input
              type="date"
              id="dob"
              name="dob"
              style={mystyle}
              className="form-control"
            />
          </GridItem>
          <GridItem xs={6} sm={6} md={6}>
            <b> Adhaar Number:</b>
            <span className="required"></span>
            <input
              type="text"
              id="adhaar_number"
              name="adhaar_number"
              style={mystyle}
              className="form-control"
            />
            <b> PAN Number:</b>
            <input
              type="text"
              name="pan_number"
              id="pan_number"
              style={mystyle}
              className="form-control"
            />

            <b> Blood Group:</b>
            <span className="required"></span>

            <select
              style={mystyle}
              className="form-control"
              id="blood_group"
              name="blood_group"
            >
              <option value="">--select--</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
            </select>

            <b>Nominee:</b>
            <span className="required"></span>
            <input
              type="text"
              id="nominee"
              name="nominee"
              style={mystyle}
              className="form-control"
              onChange={that.handle_city}
            />

            <b> Relationship with Nominee:</b>
            <span className="required"></span>
            <select
              style={mystyle}
              className="form-control"
              id="nominee_relation"
              name="nominee_relation"
            >
              <option value="">--select--</option>
              <option value="father">Father</option>
              <option value="mother">Mother</option>
              <option value="wife">Wife</option>
              <option value="husband">Husband</option>
              <option value="son">Son</option>
              <option value="daughter">Daughter</option>
              <option value="brother">Brother</option>
              <option value="sister">Sister</option>
              <option value="other">Other</option>
            </select>

            <b> Member Customer Id: &nbsp;</b>
            <label id="memberuniqid"></label>
          </GridItem>
        </GridContainer>
        <hr />
        <h6>Address Details</h6>
        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <h7>Present Address</h7>
            <br />

            <b> Address:</b>
            <span className="required"></span>
            <input
              type="text"
              name="address"
              id="address"
              style={mystyle}
              className="form-control"
              onChange={that.handle_address}
            />

            <b> State:</b>
            <span className="required"></span>

            <input
              type="text"
              id="state"
              name="state"
              className="form-control"
              style={mystyle}
              onChange={that.handle_address1}
            />

            <b>City:</b>
            <span className="required"></span>
            <input
              type="text"
              id="city"
              name="city"
              style={mystyle}
              className="form-control"
              onChange={that.handle_city}
            />

            <b> Locality:</b>
            <span className="required"></span>
            <input
              type="text"
              id="locality"
              name="locality"
              style={mystyle}
              className="form-control"
              onChange={that.handle_locality}
            />
            <b> PIN:</b>
            <span className="required"></span>
            <input
              type="text"
              id="pin"
              name="pin"
              style={mystyle}
              className="form-control"
              onChange={that.handle_pin}
            />
          </GridItem>

          <GridItem xs={6} sm={6} md={6}>
            <input
              type="checkbox"
              className=""
              name="same_adr"
              id="same_adr"
              style={{ width: "10px" }}
            />{" "}
            Same as present address.
            <br />
            <h7>Permanent Address</h7>
            <br />
            <b> Address:</b>
            <span className="required"></span>
            <input
              type="text"
              name="address_permanent"
              id="address_permanent"
              style={mystyle}
              className="form-control"
              onChange={that.handle_address}
            />
            <b> State:</b>
            <span className="required"></span>
            <input
              type="text"
              id="state_permanent"
              name="state_permanent"
              className="form-control"
              style={mystyle}
              onChange={that.handle_address1}
            />
            <b>City:</b>
            <span className="required"></span>
            <input
              type="text"
              id="city_permanent"
              name="city_permanent"
              style={mystyle}
              className="form-control"
              onChange={that.handle_city}
            />
            <b> Locality:</b>
            <span className="required"></span>
            <input
              type="text"
              id="locality_permanent"
              name="locality_permanent"
              style={mystyle}
              className="form-control"
              onChange={that.handle_locality}
            />
            <b> PIN:</b>
            <span className="required"></span>
            <input
              type="text"
              id="pin_permanent"
              name="pin_permanent"
              style={mystyle}
              className="form-control"
              onChange={that.handle_pin}
            />
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Qualification Details</h6>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Heighest Education :</b>
            <span className="required"></span>
            <div id="education"></div>

            <b>Specialization:</b>

            <div id="specialization" name="specialization"></div>

            <b>Languages Known:</b>
            <span className="required"></span>
            <div id="languages"></div>
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Experience Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Total Work Experience :</b>
            <input
              type="text"
              id="work_experience"
              name="total_experience"
              style={mystyle}
              className="form-control"
              onChange={that.handle_fname}
            />
            <b>Area Of Experience:</b>
            <div id="area_of_experience" />
            <b>Work Expeience:</b>
            <table
              id="experience_table"
              style={{ width: "100%", fontSize: "10px" }}
            >
              <thead>
                <tr>
                  <th>
                    <h8>Organization Name</h8>
                  </th>
                  <th>Years</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>

                <tr>
                  <th>
                    <input type="text" id="org" />
                  </th>
                  <th>
                    <input type="text" id="years" />
                  </th>
                  <th>
                    <input type="text" id="role" />
                  </th>
                  <th>
                    <button id="add_work">Add</button>
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
            <b>Current Salary:</b>
            <input
              type="text"
              id="salary"
              name="salary"
              style={mystyle}
              className="form-control"
            />
            <b>Interested in Abroad Job?:</b>
            <span className="required"></span>
            <br />
            No:{" "}
            <input
              type="radio"
              value="no"
              defaultChecked
              className="abroad_job"
              name="abroad_job"
              style={{ width: "10px" }}
            />
            Yes:{" "}
            <input
              type="radio"
              value="yes"
              className="abroad_job"
              name="abroad_job"
              style={{ width: "10px" }}
            />
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Bank Details</h6>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Bank Account Number :</b>
            <span className="required"></span>
            <input
              type="text"
              name="bank_account_no"
              id="bank_account_no"
              style={mystyle}
              className="form-control"
              onChange={that.handle_fname}
            />

            <b>IFSC Code:</b>
            <span className="required"></span>
            <input
              type="text"
              name="ifsc_code"
              id="ifsc_code"
              style={mystyle}
              className="form-control"
              onChange={that.handle_fname}
            />
          </GridItem>
        </GridContainer>

        <hr />

        <h6>Photo Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Photos:</b>&nbsp; &nbsp;
            <input
              type="file"
              id="file"
              name="file"
              onChange={that.handle_file}
            />
            <br />
            <br />
            <br />
          </GridItem>
        </GridContainer>

        <hr />

        <h6>KYC</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Aadhar card :</b>
            <span className="required"></span>&nbsp; &nbsp;
            <div id="no_of_files06">
              {that.state.files_upload_aadhar_card
                ? that.state.files_upload_aadhar_card.length + " files Selected"
                : ""}
            </div>
            <input
              type="file"
              id="file"
              name="file_aadhar_card"
              onChange={that.handle_file_aadhar_card}
              multiple
            />
            <br />
            <br />
            <b>Pan card :</b>&nbsp; &nbsp;
            <div id="no_of_files06">
              {that.state.files_upload_pan_card
                ? that.state.files_upload_pan_card.length + " files Selected"
                : ""}
            </div>
            <input
              type="file"
              id="file"
              name="file_pan_card"
              onChange={that.handle_file_pan_card}
              multiple
            />
            <br />
            <br />
            <br />
          </GridItem>
        </GridContainer>

        <hr />
<Employee_availability></Employee_availability>
        
        {/* <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>1st Slot</b>
            <table
              id="emergency_employee_table"
              style={{ width: "100%", fontSize: "10px" }}
            >
              <thead>
                <tr>
                  <th>
                    <h8>Days</h8>
                  </th>
                  <th>From</th>
                  <th>To</th>
                  <th>Availability</th>
                </tr>

                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "0px" }}>Sunday</h6>
                  </th>
                  <th>
                    <input type="time" id="from1_sunday" />
                  </th>
                  <th>
                    <input type="time" id="to1_sunday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "0px" }}>Monday</h6>
                  </th>
                  <th>
                    <input type="time" id="from1_monday" />
                  </th>
                  <th>
                    <input type="time" id="to1_monday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "0px" }}>Tuesday</h6>
                  </th>
                  <th>
                    <input type="time" id="from1_tuesday" />
                  </th>
                  <th>
                    <input type="time" id="to1_tuesday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "0px" }}>
                      Wednesday
                    </h6>
                  </th>
                  <th>
                    <input type="time" id="from1_wednesday" />
                  </th>
                  <th>
                    <input type="time" id="to1_wednesday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "1px" }}>
                      Thursday
                    </h6>
                  </th>
                  <th>
                    <input type="time" id="from1_thursday" />
                  </th>
                  <th>
                    <input type="time" id="to1_thursday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "1px" }}>Friday</h6>
                  </th>
                  <th>
                    <input type="time" id="from1_friday" />
                  </th>
                  <th>
                    <input type="time" id="to1_friday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <h6 style={{ fontSize: "13px", margin: "1px" }}>
                      Saturday
                    </h6>
                  </th>
                  <th>
                    <input type="time" id="from1_saturday" />
                  </th>
                  <th>
                    <input type="time" id="to1_saturday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
            <br />
            <br />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>2nd Slot</b>
            <table
              id="emergency_employee_table"
              style={{ width: "100%", fontSize: "10px" }}
            >
              <thead>
                <tr>
                  <th>From</th>
                  <th>To</th>
                  <th>Availability</th>
                </tr>

                <tr>
                  <th>
                    <input type="time" id="from2_sunday" />
                  </th>
                  <th>
                    <input type="time" id="to2_sunday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_monday" />
                  </th>
                  <th>
                    <input type="time" id="to2_monday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_tuesday" />
                  </th>
                  <th>
                    <input type="time" id="to2_tuesday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_wednesday" />
                  </th>
                  <th>
                    <input type="time" id="to2_wednesday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_thursday" />
                  </th>
                  <th>
                    <input type="time" id="to2_thursday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_friday" />
                  </th>
                  <th>
                    <input type="time" id="to2_friday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <input type="time" id="from2_saturday" />
                  </th>
                  <th>
                    <input type="time" id="to2_saturday" />
                  </th>
                  <th>
                    <input
                      type="checkbox"
                      id="check_availability"
                      style={{ width: "20px", height: "19px" }}
                    />
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
            <br />
            <br />
          </GridItem>
        </GridContainer> */}

        <hr />

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <button id="pay_to_use" className="btn btn-primary">
              Pay To Use
            </button>
            <br />
            <br />
            <br />
          </GridItem>
        </GridContainer>
        <hr />
      </div>
    );
  }
}

class Counter_edit extends React.Component {
  render() {
    return (
      <div>
        <h6>Basic Details</h6>

        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <b> Name:</b> <span id="name"></span>
            <br />
            <b> Mobile:</b>
            <span id="msisdn"></span>
            <br />
            <b> Gender:</b>
            <span id="gender"></span>
            <br />
            <b> Emergency Contact Number:</b>
            <span id="emergency_msisdn"></span>
            <br />
            <b> Email ID:</b>
            <span id="email_id"></span>
            <br />
            <b> Date of Birth:</b>
            <span id="dob"></span>
            <br />
          </GridItem>
          <GridItem xs={6} sm={6} md={6}>
            <b> Adhaar Number:</b>
            <span id="adhaar_number"></span>
            <br />
            <b> PAN Number:</b>
            <span id="pan_number"></span>
            <br />

            <b> Blood Group:</b>
            <span id="blood_group_view"></span>

            <br />

            <b>Nominee:</b>
            <span id="nominee"></span>
            <br />

            <b> Relationship with Nominee:</b>
            <span id="nominee_relation"></span>
            <br />
          </GridItem>
        </GridContainer>
        <hr />
        <h6>Address Details</h6>
        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <h7>Present Address</h7>
            <br />

            <b> Address:</b>
            <span id="address"></span>
            <br />

            <b> State:</b>
            <span id="state"></span>

            <br />

            <b>City:</b>
            <span id="city"></span>
            <br />

            <b> Locality:</b>
            <span id="locality"></span>
            <br />
            <b> PIN:</b>
            <span id="pin"></span>
            <br />
          </GridItem>

          <GridItem xs={6} sm={6} md={6}>
            <h7>Permanent Address</h7>
            <br />

            <b> Address:</b>
            <span id="address_permanent"></span>
            <br />

            <b> State:</b>
            <span id="state_permanent"></span>

            <br />
            <b>City:</b>
            <span id="city_permanent"></span>
            <br />

            <b> Locality:</b>
            <span id="locality_permanent"></span>
            <br />
            <b> PIN:</b>
            <span id="pin_permanent"></span>
            <br />
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Qualification Details</h6>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Heighest Education :</b>
            <span id="required"></span>
            <div id="education"></div>

            <b>Specialization:</b>

            <div id="specialization" name="specialization"></div>

            <b>Languages Known:</b>
            <span id="required"></span>
            <div id="languages"></div>
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Experience Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Total Work Experience :</b>
            <span id="work_experience"></span> Years.
            <br />
            <b>Area Of Experience:</b>
            <div id="area_of_experience" />
            <b>Work Expeience:</b>
            <span id="required"></span>
            <table
              id="experience_table"
              style={{ width: "100%", fontSize: "10px" }}
            >
              <thead>
                <tr>
                  <th>
                    <h8>Organization Name</h8>
                  </th>
                  <th>Years</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
            <b>Current Salary:</b>
            <span id="salary"></span>
            <br />
            <b>Interested in Abroad Job?:</b>
            <span id="abroad_job"></span>
            <br />
          </GridItem>
        </GridContainer>

        <hr />
        <h6>Bank Details</h6>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Bank Account Number :</b>
            <span id="bank_account_no"></span>

            <br />

            <b>IFSC Code:</b>
            <span id="ifsc_code"></span>
          </GridItem>
        </GridContainer>

        <hr />

        <h6>Photo Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Photos:</b>

            <div id="photo_details"></div>
          </GridItem>
        </GridContainer>

        <hr />

        <h6>Aadhar Card Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Aadhar Card:</b>

            <div id="aadhar_card_details"></div>
          </GridItem>
        </GridContainer>

        <hr />

        <h6>Pan Card Details</h6>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Pan Card:</b>

            <div id="pan_card_details"></div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}
